export default __webpack_public_path__ + "static/media/messages-pana.365012bb.svg";